import { useState } from 'react';
import { Smartphone, ChevronDown } from 'lucide-react';

/**
 * PwaInstallHelp — small, self-contained accordion that explains how to install
 * Powersure to the home screen on Android / iPhone. No native-app claims, no
 * App Store wording.
 */
export default function PwaInstallHelp() {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="mt-6 rounded-xl border border-border bg-card p-4 sm:p-5"
      data-testid="pwa-install-help"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <h3
            className="text-base font-medium text-foreground"
            style={{ fontFamily: 'Outfit' }}
            data-testid="pwa-install-title"
          >
            Powersure als app gebruiken
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed mt-1">
            U kunt Powersure op uw telefoon toevoegen aan uw beginscherm. Zo
            opent u uw Energy Control dashboard net als een gewone app.
          </p>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
            data-testid="pwa-install-toggle"
          >
            Hoe zet ik Powersure op mijn beginscherm?
            <ChevronDown
              className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`}
            />
          </button>

          {open && (
            <div
              className="mt-4 space-y-3 text-sm text-foreground"
              data-testid="pwa-install-instructions"
            >
              <div data-testid="pwa-install-android">
                <div className="text-[11px] uppercase tracking-wider text-primary/70 font-medium mb-1">
                  Android
                </div>
                <p className="text-muted-foreground leading-relaxed">
                  Open Powersure in Chrome, tik rechtsboven op het menu en kies
                  &laquo;Toevoegen aan startscherm&raquo;.
                </p>
              </div>

              <div data-testid="pwa-install-ios">
                <div className="text-[11px] uppercase tracking-wider text-primary/70 font-medium mb-1">
                  iPhone
                </div>
                <p className="text-muted-foreground leading-relaxed">
                  Open Powersure in Safari, tik op Delen en kies &laquo;Zet op
                  beginscherm&raquo;.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
